module.exports = __webpack_public_path__ + "static/media/calendar-plus.910196a8.svg";